/*
 * @ProjectName: vra
 * @FileName:
 * @PackageName:
 * @Author: Lv Zhuolin
 * @Date: 2021-03-18 10:11:00
 * @LastEditTime: 2021-01-11 13:56:52
 * @LastEditors: Lv Zhuolin
 * @Description:
 * @FilePath: /desktop/src/service/newlyMarriedService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/**
 * 新婚列表
 */
export function getNewlyMarriedData(Info) {
  return request({
    url:
      "/api/v1/newlymarried/apply/list?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 审批（同意）
 */
export function AgreeNewlyMarried(data) {
  return request({
    url: "/api/v1/newlymarried/apply/" + data.id + "/audit/agree",
    method: "PATCH",
    data: data.data
  });
}
/*
 * 审批（拒绝）
 */
export function rejectNewlyMarried(data) {
  return request({
    url: "/api/v1/newlymarried/apply/" + data.id + "/audit/refuse",
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取新婚数据详情
 */
export function getNewlyMarriedInfo(id) {
  return request({
    url: "/api/v1/newlymarried/apply/" + id,
    method: "GET"
  });
}
/**
 * 下载zip包
 */
export function downloadNewlyMarried(data) {
  return request({
    url: "/api/v1/newlymarried/downloadzip",
    method: "POST",
    responseType: "blob",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/service/newlyMarriedService.js